// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ForumModuleLayout} from 'app_components/modules/admin/forum'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import ForumService from 'app_services/admin/forum/forumService'
import ReactSelectService from 'app_services/components/reactSelectService'
import { store } from 'app_storage/redux-storage'
import ForumTagsService from 'app_services/admin/forum/forumTagsService'
// @end

// @import types
// @end

// @ADD Component types
interface IForumModuleProps {
  onHandleSubmit?: (data: any) => void
  editData?: any
  viewer: boolean
  defaultLocation?: 'student' | 'teacher' | 'guest'
  saveCreatedBy?: boolean
}
interface IForumModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ForumModule extends Component<IForumModuleProps, IForumModuleState> {

  private storeObject = store
  private forumService: ForumService
  private reactSelectService: ReactSelectService
  private screenNotifications: ScreenNotificationsUtil
  private i18nUtil: I18nUtil
  private forumTagsService: ForumTagsService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IForumModuleProps) {
    super(props)
    this.state = {}

    this.forumService = new ForumService()
    this.reactSelectService = new ReactSelectService()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.i18nUtil = new I18nUtil()
    this.forumTagsService = new ForumTagsService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onSubmit = async (data: any) => {
    // Crear los tags nuevos
    if (data.tags?.length) {
      for(let idx = 0 ; idx < data.tags.length; idx ++) {
        if (data.tags[idx].__isNew__) {
          const responseTag = await this.forumTagsService.create({ name: data.tags[idx].label });
          if (responseTag?.code === 200 && responseTag.forumTags) {
            data.tags[idx].value = responseTag.forumTags._id;
          }
        }
      }
    }
    // Enviar los datos del formulario del foro
    if (data.tags) data.tags = this.reactSelectService.formatReactSelectResponse(data.tags)
    if (data.tags === "") delete data.tags
    if (data.locations) data.locations = this.reactSelectService.formatReactSelectResponse(data.locations)
    if (data.category) data.category = data.category.value
    if (this.props.saveCreatedBy) {
      data.created_by = this.storeObject.getState().auth.user?.data?.id;
    }

    const forumResponse = await this.forumService.insertOrUpdate(
      data,
      (this.props.editData && this.props.editData._id) ? `update/${this.props.editData._id}` : 'create'
    )

    if (forumResponse) {
      let screen_notification_label = 'components.screen_notifications.add'
      if (this.props.editData && this.props.editData._id) {
        screen_notification_label = 'components.screen_notifications.update'
      }

      this.screenNotifications.fireToast(
        {
          message: `${this.i18nUtil.getTranslate(screen_notification_label)}`,
        },
        {
          position: 'bottom-right',
        }
      )

      if (this.props.onHandleSubmit) {
        this.props.onHandleSubmit(forumResponse)
      }
    }

    this.setState({ status: null })
  }

  render() {
    return(
      <ForumModuleLayout
        {...this.props}
        onHandleSubmit={this.onSubmit}
        viewer={this.props.viewer}
      />
    )
  }
}

export default connect(mapStatesToProps)(ForumModule)
